import FilterOptionList from "./FilterOptionList";
import FilterPopover from "./FilterPopover";
import {
  FilterOption,
  RESERVATION_EXTRA_OPTIONS,
  RESERVATION_FILTER_KEYS as KEYS,
  RESERVATION_FLEX_OPTIONS,
  RESERVATION_PAYMENT_METHOD_OPTIONS,
  summarise
} from "./reservationFilters";
import useFilterParams from "./useFilterParams";

const labelOf = (options: FilterOption[], value: string) =>
  options.find((o) => o.value === value)?.label || "";

// Payment, flex tier and extras, one chip each.
const FilterSelects = () => {
  const { get, set } = useFilterParams();
  const paymentMethodId = get(KEYS.paymentMethodId);

  // Flex tier and extras share the one `addOns` param. An old link may still carry two tiers;
  // the first one wins here and the next write drops the other.
  const addOns = get(KEYS.addOns).split(",").filter(Boolean);
  const flex = RESERVATION_FLEX_OPTIONS.find((o) => addOns.includes(o.value))?.value || "";
  const extras = RESERVATION_EXTRA_OPTIONS.filter((o) => addOns.includes(o.value));
  const extraValues = extras.map((o) => o.value);
  const setAddOns = (nextFlex: string, nextExtras: string[]) =>
    set({ [KEYS.addOns]: [nextFlex, ...nextExtras].filter(Boolean).join(",") });

  return (
    <>
      <FilterPopover
        label="Pagesa"
        value={labelOf(RESERVATION_PAYMENT_METHOD_OPTIONS, paymentMethodId)}
        onClear={() => set({ [KEYS.paymentMethodId]: "" })}
        panelClassName="w-56"
      >
        {(close) => (
          <FilterOptionList
            options={RESERVATION_PAYMENT_METHOD_OPTIONS}
            selected={[paymentMethodId]}
            onToggle={(value) => {
              set({ [KEYS.paymentMethodId]: value === paymentMethodId ? "" : value });
              close();
            }}
          />
        )}
      </FilterPopover>
      <FilterPopover
        label="Flex"
        value={labelOf(RESERVATION_FLEX_OPTIONS, flex)}
        onClear={() => setAddOns("", extraValues)}
        panelClassName="w-56"
      >
        {(close) => (
          <FilterOptionList
            options={RESERVATION_FLEX_OPTIONS}
            selected={[flex]}
            onToggle={(value) => {
              setAddOns(value === flex ? "" : value, extraValues);
              close();
            }}
          />
        )}
      </FilterPopover>
      <FilterPopover
        label="Shtesat"
        value={summarise(extras.map((o) => o.label))}
        onClear={() => setAddOns(flex, [])}
        panelClassName="w-56"
      >
        {() => (
          <>
            <FilterOptionList
              multiple
              options={RESERVATION_EXTRA_OPTIONS}
              selected={extraValues}
              onToggle={(value) => setAddOns(
                flex,
                extraValues.includes(value)
                  ? extraValues.filter((v) => v !== value)
                  : [...extraValues, value]
              )}
            />
            <p className="mt-2 text-xs text-neutral">Shfaqen rezervimet që i kanë të gjitha.</p>
          </>
        )}
      </FilterPopover>
    </>
  );
};

export default FilterSelects;
